import React from 'react';
import './styles/order-tracker-header.css';

interface OrderTrackerHeaderProps {
  orderId: string;
  orderPlacedAt: string;
  paymentMode: string;
  estimatedDeliveryTime?: string;
}

const OrderTrackerHeader: React.FC<OrderTrackerHeaderProps> = ({
  orderId,
  orderPlacedAt,
  paymentMode,
  estimatedDeliveryTime
}) => {
  // Format time
  const formatTime = (dateString: string) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleTimeString('en-IN', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true 
      });
    } catch (e) {
      return dateString;
    }
  };

  // Get payment status text
  const getPaymentStatus = () => {
    if (paymentMode === 'razorpay' || paymentMode === 'Razorpay') {
      return 'Paid';
    } else if (paymentMode === 'cod' || paymentMode === 'COD') {
      return 'COD';
    }
    return paymentMode;
  };

  return (
    <div className="order-tracker-header">
      <div className="header-content">
        <div className="header-row">
          <div className="header-item">
            <span className="header-label">Order ID:</span>
            <span className="header-value">{orderId}</span>
          </div>
          <div className="header-item">
            <span className="header-label">Placed:</span>
            <span className="header-value">{formatTime(orderPlacedAt)}</span>
          </div>
        </div>
        <div className="header-row">
          <div className="header-item">
            <span className="header-label">Payment:</span>
            <span className={`header-value payment-${getPaymentStatus().toLowerCase()}`}>
              {getPaymentStatus()}
            </span>
          </div>
          {estimatedDeliveryTime && (
            <div className="header-item">
              <span className="header-label">ETA:</span>
              <span className={`header-value eta ${estimatedDeliveryTime.toLowerCase() === 'cancelled' ? 'cancelled' : ''}`}>
                {estimatedDeliveryTime}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderTrackerHeader;